<template>
  <zoneRate v-if="isZoneRate" />
  <distanceRate v-else />
</template>

<script>
import zoneRate from "@/components/master/buyingTariff/OverriddenTransferZoneRate";
import distanceRate from "@/components/master/buyingTariff/OverriddenTransferDistanceRate";

export default {
  components: {
    zoneRate,
    distanceRate,
  },
  data() {
    return {
      isZoneRate: false,
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const airportAlgorithmSetting = publicSettings.find(
      (x) => x.key === "AirportAlgorithm"
    );
    this.isZoneRate = airportAlgorithmSetting && airportAlgorithmSetting.value === "Zone";
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenTransferRate.vue